import { create } from "zustand";
import { UrlHelper } from "@/utils/UrlHelper";

interface GlobalStore {
  cartId: string;
  setCartId: (cartId?: string) => void;
}

const getCartIdFromCheckoutUrl = () => UrlHelper.extractUUIDWithPrefix(window.location.href, "store/checkout/");

const getCartId = () => getCartIdFromCheckoutUrl() ?? localStorage.getItem("cartId") ?? "";

const getInitialState = () => {
  if (typeof window === "undefined") {
    return {
      cartId: "",
    };
  }

  return {
    cartId: getCartId(),
  };
};

export const useGlobalStore = create<GlobalStore>(set => ({
  ...getInitialState(),
  setCartId: (cartId?: string) =>
    set(() => {
      if (typeof window !== "undefined") {
        if (cartId) {
          localStorage.setItem("cartId", cartId);
        } else {
          localStorage.removeItem("cartId");
        }
      }

      return { cartId };
    }),
}));
